import React, { useState, useEffect, useCallback, useMemo } from 'react';
import { getData, addData, updateData, deleteData, getspeakersType } from '../../services/speakersServices';
import { Button, Modal, Form } from 'react-bootstrap';
import ReactQuill from 'react-quill';
import 'react-quill/dist/quill.snow.css';
import DataTable from 'react-data-table-component';
import Header from '../../components/Layout/Header';
import Footer from '../../components/Layout/Footer';
import Sidebar from '../../components/Layout/Sidebar';
import { validateFile} from '../../utils/validators';
import Spinner from '../../components/Spinner';
import { toast } from 'react-toastify';
import { isQuillContentEmpty } from '../../utils/common';
import default_img from '../../assets/img/default.jpg'

const modules = {
  toolbar: [
    // Font family and size
    [{ 'font': [] }, { 'size': ['small', false, 'large', 'huge'] }],

    // Headings
    [{ 'header': [1, 2, 3, 4, 5, 6, false] }],

    // Text styles
    ['bold', 'italic', 'underline', 'strike'],

    // Subscript / Superscript
    [{ 'script': 'sub' }, { 'script': 'super' }],

    // Blockquote and code block
    ['blockquote', 'code-block'],

    // Color and background
    [{ 'color': [] }, { 'background': [] }],

    // Text alignment and direction (RTL)
    [{ 'align': [] }, { 'direction': 'rtl' }],

    // Ordered / bullet list
    [{ 'list': 'ordered' }, { 'list': 'bullet' }],

    // Indent and outdent
    [{ 'indent': '-1' }, { 'indent': '+1' }],

      ['link'],

    // Clear formatting
    ['clean']
  ]
};
  
const formats = [
  'font', 'size',
  'header',
  'bold', 'italic', 'underline', 'strike',
  'script',
  'blockquote', 'code-block',
  'color', 'background',
  'align', 'direction',
  'list', 'bullet', 'indent',
  'link', 'image', 'video'
];

const Speakers = () => {
  const [data, setData] = useState([]);
  const [editingId, setEditingId] = useState(null);
  const [formData, setFormData] = useState({
    id: null,
    speaker_type: '',
    ocm_title: '',
    topicname: '',
    uploadedfile: null, // File input should be reset
    alt_name: '',
    ocm_university: '',
    ocm_country: '',
    ocm_biography: '',
    ocm_abstract: '',
    ocm_url: '',
    speaker_order: '',
    meta_title: '',
    meta_description: ''
  });
  const [modalType, setModalType] = useState(''); // 'add' or 'edit'
  const [showModal, setShowModal] = useState(false);
  const [showDeleteConfirmModal, setShowDeleteConfirmModal] = useState(false);
  const [selectedData, setselectedData] = useState(null);
  const [speakersTypes, setSpeakersTypes] = useState([]);
  const [searchText, setSearchText] = useState('');
  // const [currentPage, setCurrentPage] = useState(1);

  const [loading, setLoading] = useState(false);
  const [errors, setErrors] = useState({}); 
  // Fetch data from API
      const fetchData = useCallback(async () => {
        setLoading(true);
        try {
        const response = await getData();
        setData(response);
        }
         catch (error) { 
          console.error('Error fetching data:', error);
        }
        finally {
          setTimeout(() => {
            setLoading(false);
          }, 500);
        }
      }, []);
  
      useEffect(() => {
        fetchData();
      }, [fetchData]);
  
  useEffect(() => {
      const fetchspeakersType = async () => {
        try {
          const data = await getspeakersType(); // Fetch data from the service
          setSpeakersTypes(data); // Set the types in state
        } catch (error) {
          console.error('Error fetching speakers type:', error);
        }
      };
   
      fetchspeakersType();
    }, []);

    // Validate form data
    const validateForm = () => {
    const newErrors = {};
    if (!formData.speaker_type) newErrors.speaker_type = "Speaker Type is required";
    if (!formData.speaker_order) newErrors.speaker_order = "Order is required";
    if (!formData.topicname) newErrors.topicname = "Abstract Title is required";
    if (!formData.ocm_title) newErrors.ocm_title = "Speaker name is required";
    // if (!formData.uploadedfile && formData.uploadedfile === null) {
    // if (!errors.uploadedfile) newErrors.uploadedfile = "Speaker's Photo  is required";
    //   }
    if (!formData.ocm_country) newErrors.ocm_country = "Country is required";
    if (!formData.ocm_university) newErrors.ocm_university = "University is required";
   
    if ( isQuillContentEmpty(formData.ocm_biography.trim())) newErrors.ocm_biography = "Biography is required";
    if ( isQuillContentEmpty(formData.ocm_abstract.trim())) newErrors.ocm_abstract = "Abstract is required";
    if (!formData.meta_title) newErrors.meta_title = "Meta Title is required";
    if (!formData.meta_description) newErrors.meta_description = "Meta Description is required";
    if (formData.meta_title.length < 20 || formData.meta_title.length > 70) newErrors.meta_title = "Meta Title should be between 20 and 70 characters";
    if (formData.meta_description.length < 70 || formData.meta_description.length > 160) newErrors.meta_description = "Meta Description should be between 70 and 160 characters";
    setErrors((prev) => ({ ...prev, ...newErrors }));
    return Object.keys({ ...errors, ...newErrors }).every((key) => !errors[key] && !newErrors[key]);  
  }
    
  

    const handleChange = async(e) => {
      try{
                const { name, value, files } = e.target;
                const file = files?.[0]
                  // Create a copy of the current form data
                  let updatedData = { ...formData };
                  let updatedErrors = { ...errors };
                  if (file) {
                      const fileType = file.type.includes("image") ? "img" : "pdf";
                      const isValid = await validateFile(file, setErrors,name,fileType);
                      if (isValid) {
                        updatedData[name] = file;
                        updatedErrors[name] = '';
                      }
                      else{
                        return ; // Don't update if invalid
                      }
                } 
                  else{
                  updatedData[name] = value;
                  if (value) {
                  updatedErrors[name] = ''; // Clear error if corrected
                }
              // Field-specific validations
            if (name === 'speaker_order') {
                if (value.trim() === '') {
                updatedErrors[name] = "Order is required";
              }
              else if (!/^[0-9]+$/.test(value)) {
                updatedErrors[name] = "Order must be a number";
              } else if (Number(value) === 0) {
                updatedErrors[name] = "Order value must be greater than zero";
              } else {
                const isDuplicate = data.some((item) => {
                  if (item.id === editingId) return false; // skip current editing item
                  return item?.speaker_order === Number(value);
                });
                if (isDuplicate) {
                  updatedErrors[name] = "Order already exists";
                }
              }
            }
              }
                setFormData(updatedData);
                setErrors(updatedErrors);
              }
              catch (error) {
              console.error("Error in handleChange:", error);
            }
    };

    const handleSubmit = async (e) => {
      e.preventDefault();
       if (!validateForm()) {
        return
      }
      try{
      const form = new FormData();
      form.append('id', formData.id);
      form.append('speaker_type', formData.speaker_type);
      form.append('ocm_title', formData.ocm_title);
      form.append('topicname', formData.topicname);
      form.append('alt_name', formData.alt_name);
      form.append('ocm_university', formData.ocm_university);
      form.append('ocm_country', formData.ocm_country);
      form.append('ocm_biography', formData.ocm_biography);
      form.append('ocm_abstract', formData.ocm_abstract);
      form.append('ocm_url', formData.ocm_url);
      form.append('speaker_order', formData.speaker_order);
      form.append('meta_title', formData.meta_title);
      form.append('meta_description', formData.meta_description);
      form.append('uploadedfile', formData.uploadedfile);
  
      if (modalType === 'add') {
        const result = await addData(form);
        if (result.status === 200) {
          fetchData();
          setShowModal(false);
          toast.success("Added Successfully!", {
                                      position: 'top-right',
                                      autoClose: 3000,
                                    });
        } else {
          toast.error(result.message ||"Failed to Added data. Please try again.", {position: 'top-right',autoClose: 3000});
        }
      } else if (modalType === 'edit') {
        const result = await updateData(form);
        if (result.status === 200) {
          fetchData();
          setShowModal(false);
          toast.success("Updated Successfully!", {position: 'top-right', autoClose: 3000,});
        } else {
          toast.error(result.message ||"Failed to update data. Please try again.", {position: 'top-right',autoClose: 3000});
        }
      }
    }
    catch (error) {
          console.error("Error during form submission:", error);
      }
    };

    const handleDelete = async () => {
      try{
      if (selectedData) {
        const result = await deleteData(selectedData.id);
        if (result.status === 200) {
          fetchData();
          setShowDeleteConfirmModal(false);
          toast.success("Deleted Successfully!", {
                                            position: 'top-right',
                                            autoClose: 3000,
                                          });
        } else {
          toast.error(result.message ||"Failed to Delete data. Please try again.", {position: 'top-right',});
        }
      }
    }
    catch (error) {
          console.error('Error deleting data:', error);
        }
    };
  
    
  // Handle change for Quill editor
  const handleBiographyChange = (value) => {
    setErrors((prev) => ({ ...prev, ocm_biography: isQuillContentEmpty(value) ? 'Biography is required' : '' }));
    setFormData((prev) => ({ ...prev, ocm_biography: value }));
  };
  
  const handleResearchChange = (value) => {
    setErrors((prev) => ({ ...prev, ocm_abstract: isQuillContentEmpty(value) ? 'Abstract is required' : '' }));
    setFormData((prev) => ({ ...prev, ocm_abstract: value }));
  };
  
  const openModal = (type, data = { 
    id: null,
    speaker_type: '',
    ocm_title: '',
    topicname: '',
    uploadedfile: null, // File input should be reset
    alt_name: '',
    ocm_university: '',
    ocm_country: '',
    ocm_biography: '',
    ocm_abstract: '',
    ocm_url: '',
    speaker_order: '',
    meta_title: '',
    meta_description: ''
   }) => {
    setModalType(type);
    setFormData(data);
    setEditingId(data?.id);
    setShowModal(true);
  };

  const closeModal = () => {
    setShowModal(false);
  };

  const openDeleteConfirmModal = (data) => {
    setselectedData(data);
    setShowDeleteConfirmModal(true);
  };

  const closeDeleteConfirmModal = () => {
    setShowDeleteConfirmModal(false);
    setselectedData(null);
  };

  const handleSearchChange = (e) => {
    setSearchText(e.target.value);
  };

   // Memoized filtered data based on search query
    const filteredData = useMemo(() => {
        const filtered = data.filter(
          (data) =>
          data.ocm_title.toLowerCase().includes(searchText.toLowerCase()) 
        );
        const sortedData = [...filtered].sort((a, b) => a.speaker_order - b.speaker_order);
        return sortedData;
      }, [data, searchText]);
    

  const columns = [
    {
      name: 'Order',
      selector: (row) => row.speaker_order,
      sortable: true,
      width: '10%'
    },
    {
        name: 'Speaker Name',
        selector: (row) => (<span title={row.ocm_title}>{row.ocm_title}</span>),
        sortable: true,
        width: '15%'
    },
    {
        name: 'Speaker Type',
        selector: (row) => {
          const matched = speakersTypes.find(opt => opt.st_value === row.speaker_type);
          const label = matched ? matched.st_title : row.speaker_type;
          return <span title={label}>{label}</span>;
        },
        sortable: true,
        width: '15%'
    },
    {
    name: 'Picture',
    selector: (row) => <img src={row.ocm_pic?row.ocm_pic:default_img} width="100" alt={row.alt_name} 
    style={{ width: '60px', height: '40px', objectFit: 'cover' }}
    crossOrigin="anonymous" 
    />,
    sortable: false,
    width: '10%'
    },
    // {
    //     name: 'University',
    //     selector: (row) => (<span title={row.ocm_university}>{row.ocm_university}</span>) ,
    //     sortable: true,
    //     width: '20%'
    // },
    {
        name: 'Country',
        selector: (row) =>(<span title={row.ocm_country}>{row.ocm_country}</span>) ,
        sortable: true,
        width: '20%'
    },
    {
      name: 'Actions',
      cell: (row) => (
                <div>
                  <Button
                    className="me-2"
                    variant="warning"
                    size="sm"
                    onClick={() => openModal('edit', {
                      id: row.id,
                      speaker_type: row.speaker_type,
                      ocm_title: row.ocm_title,
                      topicname: row.topicname,
                      uploadedfile: row.ocm_pic, // File input should be reset
                      alt_name: row.alt_name,
                      ocm_university: row.ocm_university,
                      ocm_country: row.ocm_country,
                      ocm_biography: row.ocm_biography,
                      ocm_abstract: row.ocm_abstract,
                      ocm_heading: row.ocm_heading,
                      ocm_url: row.ocm_url,
                      speaker_order: row.speaker_order,
                      meta_title: row.meta_title,
                      meta_description: row.meta_description,
      
                    })}
                  >
                    Edit
                  </Button>
                  <Button
                    variant="danger"
                    size="sm"
                    onClick={() => openDeleteConfirmModal(row)}
                  >
                    Delete
                  </Button>
                </div>
              ),
      width: '20%'
    },
  ];

  useEffect(() => {
        const tooltipMap = {
          'ql-bold': 'Bold',
          'ql-italic': 'Italic',
          'ql-underline': 'Underline',
          'ql-strike': 'Strikethrough',
          'ql-script[value="sub"]': 'Subscript',
          'ql-script[value="super"]': 'Superscript',
          'ql-blockquote': 'Blockquote',
          'ql-code-block': 'Code Block',
          'ql-color': 'Text Color',
          'ql-background': 'Background Color',
          'ql-align': 'Align',
          'ql-direction': 'Text Direction',
          'ql-list[value="ordered"]': 'Ordered List',
          'ql-list[value="bullet"]': 'Bullet List',
          'ql-indent[value="-1"]': 'Outdent',
          'ql-indent[value="+1"]': 'Indent',
          'ql-link': 'Insert Link',
          'ql-clean': 'Clear Formatting',
        };
  
      const setTooltips = () => {
        Object.entries(tooltipMap).forEach(([selector, title]) => {
          const el = document.querySelector(`.ql-toolbar .ql-formats .${selector}`);
          if (el && !el.title) {
            el.setAttribute('title', title);
          }
        });
      };
  
      const observer = new MutationObserver((mutations, obs) => {
        const toolbarReady = document.querySelector('.ql-toolbar');
        if (toolbarReady) {
          setTooltips();
          obs.disconnect(); // Stop observing once done
        }
      });
  
      observer.observe(document.body, {
        childList: true,
        subtree: true,
      });
  
    return () => observer.disconnect() // Clean up on unmount
    }, []);

  return (
    <div className="d-flex">
      <Sidebar />
      <div className="main-content w-100">
        <Header />
        {loading ? (
          <div className="d-flex justify-content-center align-items-center w-100" style={{ minHeight: "300px" }}>
          <Spinner />
        </div>
      ) :(
        <div>
        <div className="container-fluid p-4">
          <div className="row">
            <div className="col-8">
              <p className='mb-3 fs-4'>Other Pages <b>/ Speakers</b></p>
            </div>
            <div className="col-4 text-end">
              <button className="btn btn-primary mb-3" onClick={() => openModal('add')}>
                Add
              </button>
            </div>
          </div>
          

          {/* Data Table for data */}
          <DataTable
            columns={columns}
            data={filteredData}
            pagination
            search
            highlightOnHover
            responsive
            striped
            paginationPerPage={10}
            paginationComponentOptions={{
            noRowsPerPage: true,
            }}
            // onChangePage={handlePageChange}
            subHeader
            subHeaderComponent={
              <div>
                <input className="form-control" type="text" placeholder="Search" value={searchText}
                  onChange={handleSearchChange}
                />
              </div>
            }
          />

          {/* Modal for Add/Edit data */}
          <Modal show={showModal} className="modal-lg" onHide={closeModal} backdrop="static">
            <Modal.Header closeButton>
              <Modal.Title className='fs-3'>{modalType === 'add' ? 'Add' : 'Edit'}</Modal.Title>
            </Modal.Header>
            <Modal.Body>
              <Form onSubmit={handleSubmit}>
                <div className='row'>
                <Form.Group className="col-md-4 mb-3">
                  <Form.Label className='form-label-custom'>Order <small className='text-danger'>*</small></Form.Label>
                  <Form.Control
                    type="number"
                    name="speaker_order"
                    value={formData.speaker_order}
                    onChange={handleChange}
                    isInvalid = {!!errors.speaker_order}
                  />
                  <Form.Control.Feedback type="invalid">{errors.speaker_order}</Form.Control.Feedback>
                  
                </Form.Group>

                <Form.Group className="col-md-4 mb-3">
                <Form.Label className='form-label-custom'>Speaker Type <small className='text-danger'>*</small></Form.Label>
                 <Form.Control className="mb-3 form-select" as="select" name="speaker_type" value={formData.speaker_type} onChange={handleChange} isInvalid = {!!errors.speaker_type} >
                    <option value="">Select Type</option>
                    {speakersTypes.map((speakers) => (
                        <option key={speakers.st_value} value={speakers.st_value}>
                        {speakers.st_title}
                        </option>
                    ))}
                </Form.Control>
                  <Form.Control.Feedback type="invalid">{errors.speaker_type}</Form.Control.Feedback>
                </Form.Group>

                <Form.Group className="col-md-4 mb-3">
                  <Form.Label className='form-label-custom'>Abstract Title <small className='text-danger'>*</small></Form.Label>
                  <Form.Control
                    type="text"
                    name="topicname"
                    value={formData.topicname}
                    onChange={handleChange}
                    isInvalid = {!!errors.topicname}
                  />
                  <Form.Control.Feedback type="invalid">{errors.topicname}</Form.Control.Feedback>
                
                </Form.Group>
                
                <Form.Group className="col-md-6 mb-3">
                  <Form.Label className='form-label-custom'>Speaker name <small className='text-danger'>*</small></Form.Label>
                  <Form.Control
                    type="text"
                    name="ocm_title"
                    value={formData.ocm_title}
                    onChange={handleChange}
                    isInvalid = {!!errors.ocm_title}
                  />
                  <Form.Control.Feedback type="invalid">{errors.ocm_title}</Form.Control.Feedback>
                  
                </Form.Group>
                
                <Form.Group className="col-md-6 mb-3">
                  <Form.Label className='form-label-custom'>University <small className='text-danger'>*</small></Form.Label>
                  <Form.Control
                    type="text"
                    name="ocm_university"
                    value={formData.ocm_university}
                    onChange={handleChange}
                    isInvalid = {!!errors.ocm_university}
                  />
                  <Form.Control.Feedback type="invalid">{errors.ocm_university}</Form.Control.Feedback>

                </Form.Group>
                <Form.Group className="col-md-6 mb-3">
                  <Form.Label className='form-label-custom'>Country <small className='text-danger'>*</small></Form.Label>
                  <Form.Control
                    type="text"
                    name="ocm_country"
                    value={formData.ocm_country}
                    onChange={handleChange}
                    isInvalid = {!!errors.ocm_country}
                  />
                  <Form.Control.Feedback type="invalid">{errors.ocm_country}</Form.Control.Feedback>

                </Form.Group>
                <Form.Group className="col-md-6 mb-3">
                  <Form.Label className='form-label-custom'>
                  Speaker's Photo <small className='text-primary'>(Dimension:300x300 | Size:15kb to 30kb)</small>
                  </Form.Label>
                  <Form.Control
                    type="file"
                    name="uploadedfile"
                    onChange={handleChange}
                    isInvalid = {!!errors.uploadedfile}
                    accept="image/*"
                  />
                  <Form.Control.Feedback type="invalid">{errors.uploadedfile}</Form.Control.Feedback>
                </Form.Group>
                <Form.Group className="mb-3">
                <Form.Label className='form-label-custom' >Abstract<small className='text-danger'>*</small></Form.Label>
                <ReactQuill
                    value={formData.ocm_abstract}
                    onChange={handleResearchChange}
                    theme="snow"
                    modules={modules}
                    formats={formats}
                    placeholder="Enter Abstract"
                    className={`react-quill-editor ${errors.ocm_abstract ? 'border border border-1 border-danger rounded' : ''}`}
                />
                {errors.ocm_abstract && (
                    <div className="invalid-feedback d-block">
                      {errors.ocm_abstract}
                    </div>
                  )}
                </Form.Group>
                
                <Form.Group className="mb-3">
                <Form.Label className='form-label-custom' >Biography <small className='text-danger'>*</small></Form.Label>
                <ReactQuill
                    value={formData.ocm_biography}
                    onChange={handleBiographyChange}
                    theme="snow"
                    modules={modules}
                    formats={formats}
                    placeholder="Enter Biography"
                    className={`react-quill-editor ${errors.ocm_biography ? 'border border border-1 border-danger rounded' : ''}`}
                />
                {errors.ocm_biography && (
                    <div className="invalid-feedback d-block">
                      {errors.ocm_biography}
                    </div>
                  )}
                </Form.Group>

              


                <Form.Group className="col-md-6 mb-3">
                  <Form.Label className='form-label-custom'>Meta Title <small className='text-danger'>*</small> <small className='text-primary'>Char Limit: 20 -70 | Current Char Count: {formData.meta_title.length}</small></Form.Label>
                  <Form.Control
                    as="textarea"
                    rows={8}
                    name="meta_title"
                    value={formData.meta_title}
                    onChange={handleChange}
                    isInvalid = {!!errors.meta_title}
                  />
                  <Form.Control.Feedback type="invalid">{errors.meta_title}</Form.Control.Feedback>
                </Form.Group>

                <Form.Group className="col-md-6 mb-3">
                  <Form.Label className='form-label-custom'>Meta Description <small className='text-danger'>*</small> <small className='text-primary'>Char Limit: 70 -160 | Current Char Count: {formData.meta_description.length}</small></Form.Label>
                  <Form.Control
                    as="textarea"
                    rows={8}
                    name="meta_description"
                    value={formData.meta_description}
                    onChange={handleChange}
                    isInvalid = {!!errors.meta_description}
                  />
                  <Form.Control.Feedback type="invalid">{errors.meta_description}</Form.Control.Feedback>
                </Form.Group>
                </div>

                <Modal.Footer className='border-0'>
                  <Button variant="secondary" onClick={closeModal}>
                    Cancel
                  </Button>
                  <Button variant="primary" type="submit">
                    {modalType === 'add' ? 'Add' : 'Save'}
                  </Button>
                </Modal.Footer>
              </Form>
            </Modal.Body>
          </Modal>

          {/* Delete Confirmation Modal */}
          <Modal show={showDeleteConfirmModal} onHide={closeDeleteConfirmModal}>
            <Modal.Header closeButton>
              <Modal.Title>Delete</Modal.Title>
            </Modal.Header>
            <Modal.Body>
              <p>Are you sure you want to delete this row?</p>
            </Modal.Body>
            <Modal.Footer>
              <Button variant="secondary" onClick={closeDeleteConfirmModal}>
                Cancel
              </Button>
              <Button variant="danger" onClick={handleDelete}>
                Yes, Delete
              </Button>
            </Modal.Footer>
          </Modal>
        </div>
        <Footer />
        </div>
      )}
      </div>
    </div>
  );
};

export default Speakers;